import { homeList } from '@/json/home1.js';
export default{
	state:{
		// token:null,
		homeList: homeList,
        cartListNum: JSON.parse(sessionStorage.getItem('cartList')) ?  JSON.parse(sessionStorage.getItem('cartList')).length : ''
	},
	getters:{},
	mutations:{
        getCartListNum (state) {
            state.cartListNum = JSON.parse(sessionStorage.getItem('cartList')) ?  JSON.parse(sessionStorage.getItem('cartList')).length : ''
        }
	},
	actions:{},
	
}